/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface OrganisationUnitsPreferences {
    distanceUnit: OrganisationUnitsPreferences.DistanceUnit;
    heightUnit: OrganisationUnitsPreferences.HeightUnit;
    speedUnit: OrganisationUnitsPreferences.SpeedUnit;
    temperatureUnit: OrganisationUnitsPreferences.TemperatureUnit;
    weightUnit: OrganisationUnitsPreferences.WeightUnit;
    dateFormat: string;
    dateTimeFormat: string;
    timeFormat: string;
}
export namespace OrganisationUnitsPreferences {
    export type DistanceUnit = 'METRE' | 'MILE' | 'NAUTICAL_MILE';
    export const DistanceUnit = {
        METRE: 'METRE' as DistanceUnit,
        MILE: 'MILE' as DistanceUnit,
        NAUTICAL_MILE: 'NAUTICAL_MILE' as DistanceUnit
    };
    export type HeightUnit = 'METRE' | 'FEET';
    export const HeightUnit = {
        METRE: 'METRE' as HeightUnit,
        FEET: 'FEET' as HeightUnit
    };
    export type SpeedUnit =
        | 'METRES_PER_SECOND'
        | 'KILOMETRES_PER_HOUR'
        | 'MILES_PER_HOUR'
        | 'KNOTS'
        | 'FEET_PER_SECOND';
    export const SpeedUnit = {
        METRES_PER_SECOND: 'METRES_PER_SECOND' as SpeedUnit,
        KILOMETRES_PER_HOUR: 'KILOMETRES_PER_HOUR' as SpeedUnit,
        MILES_PER_HOUR: 'MILES_PER_HOUR' as SpeedUnit,
        KNOTS: 'KNOTS' as SpeedUnit,
        FEET_PER_SECOND: 'FEET_PER_SECOND' as SpeedUnit
    };
    export type TemperatureUnit = 'CELSIUS' | 'FAHRENHEIT';
    export const TemperatureUnit = {
        CELSIUS: 'CELSIUS' as TemperatureUnit,
        FAHRENHEIT: 'FAHRENHEIT' as TemperatureUnit
    };
    export type WeightUnit = 'GRAM' | 'POUND';
    export const WeightUnit = {
        GRAM: 'GRAM' as WeightUnit,
        POUND: 'POUND' as WeightUnit
    };
}
